import React from 'react'
import {
  UserCircleIcon,
  ChevronRightIcon,
  AdjustmentsHorizontalIcon,
  ChatBubbleOvalLeftEllipsisIcon,
} from '@heroicons/react/24/outline'
import { Link } from 'gatsby'
import { SectionContainer } from '../SectionContainer'
import { LinkButton } from '../../common/menu/linkButton'
import { TitleHighlight } from '../../ui/typo/TitleHighlight'
import { HomeHeading } from './Heading'

export const LamatchSection = () => {
  const steps = [
    {
      icon: AdjustmentsHorizontalIcon,
      label: 'Étape 1: Renseigne ta recherche et valide ton profil.',
    },
    {
      icon: UserCircleIcon,
      label: 'Étape 2: Mets ton profil en ligne pour les cabinets.',
    },
    {
      icon: ChatBubbleOvalLeftEllipsisIcon,
      label: 'Étape 3: Reçois des propositions de cabinets en direct.',
    },
  ]

  return (
    <SectionContainer>
      <div>
        <img
          className="object-cover w-full h-full"
          src="/lamatch.webp"
          alt="Illustration de l'application Lamatch"
        />
      </div>
      <div className="px-4 space-y-8 md:px-12 md:space-y-4 lg:space-y-8 xl:space-y-10">
        <HomeHeading additionalClasses="text-center md:text-left">
          Comment se fait le <TitleHighlight>matching</TitleHighlight> avec les
          cabinets&nbsp;?
        </HomeHeading>

        <div className="space-y-6">
          <p className="text-lg font-medium text-night">
            Tu veux que les cabinets te contactent avec des propositions&nbsp;?
          </p>
          <ul className="space-y-2 list-none md:space-y-4 lg:space-y-6">
            {steps.map(({ icon, label }) => (
              <li key={label} className="flex items-center gap-2">
                {React.createElement(icon, {
                  strokeWidth: 2,
                  className: 'h-6 text-night w-6 hidden md:block',
                })}
                <span className="font-thin text-night">{label}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-4 md:space-y-0 md:space-x-4 md:flex md:items-center">
          <LinkButton
            label="Créer mon profil"
            href="https://lamadash.fr/signup_login_candidat"
            isExternal
            isInverted
          />
          <Link
            to="/offres"
            className="flex items-center text-center text-night"
          >
            Voir les offres d&apos;emploi
            <ChevronRightIcon className="w-6 h-6 ml-1 text-night" />
          </Link>
        </div>
      </div>
    </SectionContainer>
  )
}
